module.exports = __webpack_public_path__ + "img/p-3.304794eb.jpg";